import React from "react";
import Slider from "react-slick";
import "./TestimonialSection.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    name: "Robert Steven",
    location: "New York, USA",
    role: "Tech Entrepreneur",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    text: "This platform revolutionized how I approach business. The community support is absolutely phenomenal and the results speak for themselves.",
    rating: 5,
    company: "InnovateTech"
  },
  {
    name: "Emmie Smith",
    location: "London, UK",
    role: "Creative Director",
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b830?w=150&h=150&fit=crop&crop=face",
    text: "An extraordinary experience that exceeded all my expectations. The level of detail and personal attention is truly remarkable.",
    rating: 5,
    company: "Design Studios"
  },
  {
    name: "David Miller",
    location: "Berlin, Germany",
    role: "Software Architect",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    text: "Elegant, intuitive, and powerful. The support team responds faster than I could ever imagine. Absolutely game-changing.",
    rating: 5,
    company: "TechFlow GmbH"
  },
  {
    name: "Sophia Turner",
    location: "Toronto, Canada",
    role: "Product Manager",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    text: "The most comprehensive and well-structured platform I've ever used. Every feature is thoughtfully designed and beautifully executed.",
    rating: 5,
    company: "Maple Innovations"
  },
  {
    name: "Aarav Patel",
    location: "Mumbai, India",
    role: "Data Scientist",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&crop=face",
    text: "Incredible learning experience with a vibrant community. The practical approach and real-world applications are outstanding.",
    rating: 5,
    company: "DataVision AI"
  },
  {
    name: "Elena Gomez",
    location: "Madrid, Spain",
    role: "UX Designer",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
    text: "Perfectly crafted with attention to every detail. The user experience is flawless and the results are beyond impressive.",
    rating: 5,
    company: "Creative Labs"
  },
];

// Custom Navigation Components
const NextArrow = ({ onClick }) => (
  <div className="testimonial-nav testimonial-nav-next" onClick={onClick}>
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M9 18l6-6-6-6" />
    </svg>
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="testimonial-nav testimonial-nav-prev" onClick={onClick}>
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M15 18l-6-6 6-6" />
    </svg>
  </div>
);

// Star Rating Component
const StarRating = ({ rating }) => (
  <div className="star-rating">
    {[...Array(5)].map((_, i) => (
      <svg
        key={i}
        className={`star ${i < rating ? '' : 'empty'}`}
        viewBox="0 0 24 24"
        fill={i < rating ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth="2"
      >
        <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
      </svg>
    ))}
  </div>
);

// Slider Settings
const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 800,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  pauseOnHover: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  centerMode: true,
  centerPadding: '0px',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        centerMode: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        centerMode: false,
      },
    },
  ],
};

const TestimonialSection = () => {
  return (
    <section className="testimonial-section">
      <div className="testimonial-container">
        
        {/* Header */}
        <div className="testimonial-header">
          <div className="testimonial-badge">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
            </svg>
            <span>Testimonials</span>
          </div>
          <h2>Loved by thousands</h2>
          <p className="testimonial-subtitle">
            Discover why industry leaders choose our platform to transform their business and achieve extraordinary results
          </p>
        </div>

        {/* Testimonial Slider */}
        <div className="testimonial-slider-container">
          <Slider {...sliderSettings}>
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-slide">
                <div className="testimonial-card">
                  
                  {/* Quote Icon */}
                  <svg className="quote-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" />
                    <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" />
                  </svg>

                  {/* User Info */}
                  <div className="user-info">
                    <div className="user-avatar">
                      <img src={testimonial.image} alt={testimonial.name} />
                    </div>
                    <div className="user-details">
                      <h3>{testimonial.name}</h3>
                      <p className="user-role">{testimonial.role}</p>
                      <p className="user-location">{testimonial.location}</p>
                    </div>
                  </div>

                  {/* Star Rating */}
                  <StarRating rating={testimonial.rating} />

                  {/* Testimonial Message */}
                  <p className="testimonial-message">
                    {testimonial.text}
                  </p>

                  {/* Company Info */}
                  <div className="company-info">
                    <div className="company-dot"></div>
                    <span>{testimonial.company}</span>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;